/**
 * Created by Carsten Hibbeler on 11.02.2016.
 */
/**
 * modded version of https://github.com/perliedman/leaflet-realtime/blob/master/src/L.Realtime.js
 * Copyright (c) 2014, Per Liedman (per@liedman.net)
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 */
import L from 'external/leaflet';

import { Client } from 'external/lwr-client';

const RemoteDataGeoJsonLayer = L.GeoJSON.extend({

    options: {
        getFeatureId: function (f) {
            //id is only valid for one modelClassName aka. type!
            return f.properties.type + f.properties.id;
        },

        updateFeature: function (f, oldLayer, newLayer) {
            if (f.geometry.type === 'Point') {
                oldLayer.setLatLng(newLayer.getLatLng());
                return oldLayer;
            } else {
                return newLayer;
            }
        }
    },

    initialize: function (servicePath, method, options) {
        L.GeoJSON.prototype.initialize.call(this, undefined, options);

        const serviceWithContext = (m, o, c) => Client.invokeWithContext(servicePath + m, o, c);
        this.request = () => {
            if (options.data && options.context) {
                serviceWithContext(method, options.data, options.context).then(this._onNewData.bind(this), (e) => console.error(e));
            } else {
                serviceWithContext(method, options).then(this._onNewData.bind(this), (e) => console.error(e));
            }
        };

        this._features = {};
        this._featureLayers = {};

        this.update();
    },

    update: function () {
        this.request();
        return this;
    },

    remove: function (geojson) {
        let features = L.Util.isArray(geojson) ? geojson : geojson.features ? geojson.features : [ geojson ],
            exit = {},
            i,
            len,
            fId;

        for (i = 0, len = features.length; i < len; i++) {
            fId = this.options.getFeatureId(features[ i ]);
            this.removeLayer(this._featureLayers[ fId ]);
            exit[ fId ] = this._features[ fId ];
            delete this._features[ fId ];
            delete this._featureLayers[ fId ];
        }

        L.Evented.prototype.fire.call(this, 'update', {
            features: this._features,
            enter: {},
            update: {},
            exit: exit
        });

        return this;
    },

    getFeatureLayer: function (id, className) {
        if (!className) {
            console.error('Missing className');
        }
        return this._featureLayers[ className + id ];
    },

    getFeature: function (id, className) {
        if (!className) {
            console.error('Missing className');
        }
        return this._features[ className + id ];
    },

    _onNewData: function (response) {
        let oef = this.options.onEachFeature,
            layersToRemove = [],
            features = {},
            enter = {},
            update = {},
            exit = {},
            i;

        this.options.onEachFeature = L.bind(function onEachFeature(f, l) {

            let fId,
                oldLayer,
                newLayer;

            if (oef) {
                oef(f, l);
            }

            fId = this.options.getFeatureId(f);
            oldLayer = this._featureLayers[ fId ];

            if (oldLayer) {
                newLayer = this.options.updateFeature(f, oldLayer, l);
                if (newLayer !== oldLayer) {
                    this.removeLayer(oldLayer);
                }
                if (newLayer !== l) {
                    layersToRemove.push(l);
                }

                l = newLayer;
                update[ fId ] = f;
            } else {
                enter[ fId ] = f;
            }

            this._featureLayers[ fId ] = l;
            this._features[ fId ] = features[ fId ] = f;
        }, this);

        this.addData(response);


        exit = this._removeUnknown(features);

        for (i = 0; i < layersToRemove.length; i++) {
            this.removeLayer(layersToRemove[ i ]);
        }

        L.Evented.prototype.fire.call(this, 'update', {
            features: this._features,
            enter: enter,
            update: update,
            exit: exit
        });

        this.options.onEachFeature = oef;
    },

    _removeUnknown: function (known) {
        let fId, removed = {};
        for (fId in this._featureLayers) {
            if (!known[ fId ] && this._featureLayers.hasOwnProperty(fId)) {
                this.removeLayer(this._featureLayers[ fId ]);
                removed[ fId ] = this._features[ fId ];
                delete this._featureLayers[ fId ];
                delete this._features[ fId ];
            }
        }

        return removed;
    }


});

export default RemoteDataGeoJsonLayer;



// WEBPACK FOOTER //
// ./js/layer/RemoteDataGeoJsonLayer.js